import { createContext } from 'react';
import type { SATConnectionContextValue } from './satConnection.types';

export const SATConnectionContext =
	createContext<SATConnectionContextValue | null>(null);

export const SATRelinkContext = createContext<(relinking: boolean) => void>(
	() => undefined,
);
